import React, {useEffect, useState} from 'react'
import {useAuth} from '../../modules/auth'
import {TablaUsuarios} from '../../components/TablaUsuarios/TablaUsuarios'
import axios from 'axios'
import {KTSVG} from '../../../_metronic/helpers'
import ReactPaginate from 'react-paginate'
import {Modal} from 'react-bootstrap'
import Swal from 'sweetalert2'
import { ModalUsuario } from '../../components/ModalUsuario/ModalUsuario'

function Usuarios() {
  const API_URL = process.env.REACT_APP_API_URL
  const {currentUser, logout} = useAuth()

  const fecha = new Date()
  const [fechaLastUpdate, setFechaLastUpdate] = useState(new Date())

  const [loadingPage, setLoadingPage] = useState(false)

  const [usuarios, setUsuarios] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [loadingNewExp, setLoadingNewExp] = useState(false)

  const [usuario, setUsuario] = useState([])
  const [showNewUser, setShowNewUser] = useState(false)
  const handleCloseNewUser = () => setShowNewUser(false)
  const handleShowNewUser = () => setShowNewUser(true)

  let searchedUsuarios = new Array()

  if (usuarios.length !== 0) {
    searchedUsuarios = usuarios.filter((usuario) => {
      let usuarioFullName = usuario.first_name + " " + usuario.last_name;
      return usuarioFullName.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(searchValue.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''))
    })
  }

  let searchedUsuario = new Array();
  searchedUsuario = usuario;

  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage, setRecordsPerPage] = useState(25)

  const indexOfLastRecord = currentPage * recordsPerPage
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
  const currentRecords = searchedUsuarios.slice(indexOfFirstRecord, indexOfLastRecord)

  const paginate = ({selected}) => {
    setCurrentPage(selected + 1)
  }

  function addZero(i) {
    if (i < 10) {
      i = '0' + i
    }
    return i
  }

  function formatoFecha(fecha, formato) {
    const meses = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ]

    const map = {
      dd: fecha.getDate(),
      mm: meses[fecha.getMonth()],
      yyyy: fecha.getFullYear(),
      HH: addZero(fecha.getHours()),
      MM: addZero(fecha.getMinutes()),
    }

    return formato.replace(/mm|dd|HH|MM|yyyy/gi, (matched) => map[matched])
  }

  const deleteUser = (idUser) => {
    console.log(idUser)

    var data = {
      idUser: idUser,
    }

    Swal.fire({
      title: '¿Desea eliminar el usuario?',
      text: 'Una vez eliminado se perderá el registro de este.',
      showDenyButton: true,
      //showCancelButton: true,
      confirmButtonText: 'Eliminar',
      confirmButtonColor: '#C6313A',
      denyButtonText: 'Cancelar',
      denyButtonColor: '#42817f',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        //Swal.fire("Saved!", "", "success");
        setLoadingPage(true)
        axios.post(API_URL + '/app/deleteUser', data, {}).then(
          (res) => {
            console.log(res)
            misUsuarios()
            setLoadingPage(false)

            Swal.fire({
              title: 'Usuario eliminado',
              text: 'Se ha eliminado con éxito el usuario.',
              confirmButtonColor: '#42817f',
              confirmButtonText: 'Ok',
            }).then(function () {})
          },
          (error) => {
            alert(error)
          }
        )
      } else if (result.isDenied) {
        //Swal.fire("Changes are not saved", "", "info");
      }
    })
  }

  const showUser = (idUser) => {
    //setLoadingPage(true)

    //var data = []
    /* var data = {
      idUser: idUser
    }*/

    axios
      .get(API_URL + '/app/myProfile/' + idUser)
      .then((response) => {
        console.log('DATOS USUARIO')
        console.log(idUser)
        console.log(response.data)
        setUsuario(response.data)
        setLoadingPage(false)
      })
      .catch((error) => console.error(error))

    handleShowNewUser()
  }

  const misUsuarios = () => {
    setLoadingPage(true)
    axios
      .get(API_URL + '/app/usuarios/' + currentUser.id)
      .then((response) => {
        console.log(response.data)
        setUsuarios(response.data)
        setLoadingPage(false)
      })
      .catch((error) => console.error(error))
  }

  useEffect(() => {
    misUsuarios()
  }, [])

  return (
    <>
      {/* Header */}
      <Modal show={showNewUser} onHide={handleCloseNewUser}>
        <Modal.Header closeButton>
          <Modal.Title>Detalle del usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalUsuario usuario={searchedUsuario} showUser={showUser} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewUser}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>

      <div className='row gy-5 g-xl-8'>
        <div className='col-lg-8'>
          <h2>Bienvenido</h2>
          <p>{formatoFecha(fecha, 'dd de mm yyyy - HH:MM hrs')}</p>
        </div>
      </div>

      <div className='row gy-5 g-xl-8 card card-custom shadow mt-4 pb-10'>
        <div className='row p-6'>
          <div className='col-md-4'>
            {/* <h4>Boletín jurisdiccional</h4>
            <li className='d-flex align-items-center py-2'>
              <span className='bullet bullet-dot bg-success h-15px w-15px me-5'></span>
              <b>Última conexión al boletín:&nbsp;</b>
              {formatoFecha(fechaLastUpdate, 'dd de mm yyyy - HH:MM hrs')}
            </li> */}
          </div>
          <div className='col-md-8 text-right'>
            <div className='form-group float-end pt-3'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 ms-0'
              />
              <input
                type='text'
                className='form-control form-control-flush ps-10 inicio-search-box mt-n10'
                name='search'
                placeholder='Buscar usuario...'
                value={searchValue}
                onChange={(event) => {
                  setSearchValue(event.target.value)
                  setCurrentPage(1)
                }}
              />
            </div>
          </div>
        </div>

        {/* Exp container */}
        <div className='row mb-10 gy-5'>
          {!loadingPage && (
            <>
              <div className='expedientes'>
                <table className='table table-rounded table-hover table-row-bordered border gy-7 gs-7'>
                  <thead>
                    <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200 expedientes-header'>
                      <th scope='col'>
                        <b>Nombre</b>
                      </th>
                      <th scope='col'>
                        <b>Teléfono</b>
                      </th>
                      <th scope='col'>
                        <b>Correo</b>
                      </th>
                      <th scope='col'>
                        <b>Empresa</b>
                      </th>
                      <th scope='col'>
                        <b>Número de empleados</b>
                      </th>
                      <th scope='col'>
                        <b>Estado</b>
                      </th>
                      <th scope='col'>
                        <b>Ciudad</b>
                      </th>
                      <th scope='col'>
                        <b>Expedientes</b>
                      </th>
                      <th scope='col'>
                        <b>Días restantes </b>
                      </th>
                      <th scope='col'>
                        <b>Plan</b>
                      </th>
                      <th scope='col'>
                        <b>Status</b>
                      </th>
                      <th scope='col'>
                        <b>Acciones</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <TablaUsuarios
                      usuarios={currentRecords}
                      deleteUser={deleteUser}
                      showUser={showUser}
                    />
                  </tbody>
                </table>
              </div>
            </>
          )}
          {loadingPage && (
            <>
              <div className='d-flex flex-center'>
                <h2>
                  <span className='spinner-border spinner-border align-middle ms-2'></span>
                  Cargando...
                </h2>
              </div>
            </>
          )}
        </div>
        <div className='row text-center'>
          <p>
            Mostrando {currentRecords.length} de {searchedUsuarios.length} resultados
          </p>
        </div>
        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(searchedUsuarios.length / recordsPerPage)}
          breakLabel={'...'}
          previousLabel={'< Anterior'}
          nextLabel={'Siguiente >'}
          containerClassName={'pagination'}
          pageLinkClassName={'page-number'}
          previousLinkClassName={'page-number'}
          nextLinkClassName={'page-number'}
          activeLinkClassName={'active'}
          forcePage={currentPage - 1}
        />
      </div>
    </>
  )
}

export {Usuarios}
